import { render, staticRenderFns } from "./ModalProductManagement.vue?vue&type=template&id=1ea8e547"
import script from "./ModalProductManagement.vue?vue&type=script&lang=js"
export * from "./ModalProductManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports